module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    class: _vm.classObject,
    attrs: {
      "type": "button"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.displayLabel)
    },
    on: {
      "click": _vm.click
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dac84c3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/input-button.vue
// module id = 33
// module chunks = 0